import React from 'react';
import LookupField from '../../../components/LookupField';
import { F2110 } from '../../../services/p2201Api';

interface Tab1Props {
  formData: Partial<F2110>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof F2110) => F2110[keyof F2110];
  setField: (key: keyof F2110, value: F2110[keyof F2110]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

/** Tab 1: Basic Info (Page1 controls from ui_spec) */
const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => {
  return (
    <div className="tab-content-section">
      <div className="form-grid">
        {/* Warehouse code + name (BR-03) — LookupField replaces plain input (hasDblClick PW1105F6) */}
        <label>庫位</label>
        <div className="lookup-field">
          <LookupField
            lookupType="warehouse"
            value={String(getField('f2110_07') || '')}
            onChange={(code, name) => {
              setField('f2110_07', code);
              if (name) resolveSingleName('warehouse', 'warehouse', code);
            }}
            onCodeConfirm={code => resolveSingleName('warehouse', 'warehouse', code)}
            disabled={!isEditing}
            maxLength={4}
            title="庫位查詢"
            style={{ width: 120 }} contractFieldId="f2110_07"
          />
          <span className="lookup-name">{names.warehouse || ''}</span>
        </div>

        {/* Person code + name (BR-02) — LookupField replaces plain input (hasDblClick PW9101F6) */}
        <label>人員代號</label>
        <div className="lookup-field">
          <LookupField
            lookupType="employee"
            value={String(getField('f2110_12') || '')}
            onChange={(code, name) => {
              setField('f2110_12', code);
              if (name) resolveSingleName('employee', 'employee', code);
            }}
            onCodeConfirm={code => resolveSingleName('employee', 'employee', code)}
            disabled={!isEditing}
            maxLength={8}
            title="人員查詢"
            style={{ width: 140 }} contractFieldId="f2110_12"
          />
          <span className="lookup-name">{names.employee || ''}</span>
        </div>

        {/* Vendor code + name (BR-01) — LookupField replaces plain input (hasDblClick PW1104F5) */}
        <label>廠商代號</label>
        <div className="lookup-field">
          <LookupField
            lookupType="vendor"
            value={String(getField('f2110_13') || '')}
            onChange={(code, name) => {
              setField('f2110_13', code);
              if (name) resolveSingleName('vendor', 'vendor', code);
            }}
            onCodeConfirm={code => resolveSingleName('vendor', 'vendor', code)}
            disabled={!isEditing}
            maxLength={12}
            title="廠商查詢"
            style={{ width: 160 }} contractFieldId="f2110_13"
          />
          <span className="lookup-name">{names.vendor || ''}</span>
        </div>

        {/* Description (BR-04 all DblClick/Valid/Refresh events are dead code — plain input is correct) */}
        <label>單據說明</label>
        <div style={{ gridColumn: 'span 3' }}>
          <input
            type="text"
            value={String(getField('f2110_15') || '')}
            onChange={e => setField('f2110_15', e.target.value)}
            disabled={!isEditing}
            maxLength={80}
            style={{ width: '100%' }} data-contract-field="f2110_15"
          />
        </div>
      </div>
    </div>
  );
});

Tab1BasicInfo.displayName = 'Tab1BasicInfo';
export default Tab1BasicInfo;
